module.exports = __webpack_public_path__ + "static/media/News_and_info.3239463c.jpg";